import { css } from '@fable/theme'
import { ReaderStatCardItem } from './ReaderStatCard'
import { FlexBox } from '@fable/components'
import { ProgressCircle } from '../shared'
import { useStats } from '../../lib/ctx/stats'
import {
  getBestStreakResult,
  getRatingResult,
  getReadingGoalResult,
} from '../../lib/utils'
import { StatsUserImage } from '../StatsUserImage'

export const useStatCards = () => {
  const [stats, goalOptIn, isV2, year] = useStats((s) => [
    s.stats,
    s.goalOptIn,
    s.isV2,
    s.year,
  ])
  const { percentage, booksRead, numBooks } = getReadingGoalResult({
    stats,
  })
  const { bestStreakText, bestStreakUnit } = getBestStreakResult(stats)
  const { averageRating, averageRatingUnit } = getRatingResult(stats)

  const statsList: ReaderStatCardItem[] = [
    {
      hide: false,
      title: 'Best streak',
      value: bestStreakText,
      unit: bestStreakUnit,
      icon: 'flashlight',
    },
    {
      hide: isV2 ? !goalOptIn : false,
      title: `${year} Goal`,
      value: (
        <span
          className={css`
            font-size: ${numBooks > 99 ? 22 : 25}px;
          `}
        >
          {booksRead}
          &nbsp;
          <span
            className={css`
              opacity: 50%;
            `}
          >
            of {numBooks}
          </span>
        </span>
      ),
      unit: 'books',
      element: (
        <FlexBox
          className={css`
            position: relative;
            width: 40px;
            height: 40px;
            transform: translateY(3px);
          `}
          centerAll
        >
          <FlexBox
            className={css`
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            `}
            centerAll
          >
            <ProgressCircle
              percentage={percentage}
              strokeWidth={20}
              width={56}
              cutout
            />
          </FlexBox>
          <StatsUserImage size="28px" imageSize={80} />
        </FlexBox>
      ),
    },
    {
      hide: false,
      title: 'Avg. rating',
      value: averageRating === 0 ? 'N/A' : averageRating,
      unit: averageRatingUnit,
      icon: 'user-heart',
    },
  ]

  return statsList
}
